import React from "react";
import { useSelector } from "react-redux";
import { RuvnlTitle } from "../components";

import Hamburger from "../../../components/Hamburger";
import { TabSwitcher } from "../Raj_Dashboard";
import { ReactComponent as Session } from "../../../icons/Session_icon.svg";
import { ReactComponent as Target } from "../../../icons/target_date_icon.svg";
interface SessionInfoProps {
  modSessionToken?: string;
  selectDate?: string;
}

const SessionInfo: React.FC<SessionInfoProps> = () => {
  const preSelectedDate = useSelector(
    (state: any) => state.modDemoDate.selectedDate
  );
  const modSessionToken = useSelector(
    (state: any) => state.modDemoSessionToken.modSessionToken
  );
  const formatDateWithSuffix = (dateString: string): string => {
    const date = new Date(dateString);
    const day = date.getDate();
    const year = date.getFullYear();

    const month = date.toLocaleString("default", { month: "long" });

    // Add suffix to the day (1st, 2nd, 3rd, etc.)
    const getDayWithSuffix = (d: number): string => {
      if (d > 3 && d < 21) return `${d}th`;
      switch (d % 10) {
        case 1:
          return `${d}st`;
        case 2:
          return `${d}nd`;
        case 3:
          return `${d}rd`;
        default:
          return `${d}th`;
      }
    };

    return `${getDayWithSuffix(day)} ${month} ${year}`;
  };
  const TargetDate = formatDateWithSuffix(preSelectedDate);
  return (
    <div className="dashboard-header flex items-center justify-between px-4">
      <div className="flex items-start w-full">
        <Hamburger />
        {/* <div className="ms-5">
          <TabSwitcher />
        </div> */}
        <div>
          <h5 className="text-[18px] text-[#6F6D7C] ms-5 font-medium">
            MeritEngine
          </h5>
        </div>
      </div>
      <div className="flex justify-center text-center w-full ml-[-60px]">
        <RuvnlTitle />
      </div>
      <div className="flex items-center justify-end gap-4 w-full">
        {/* Session ID Display */}
        <div className="flex items-center gap-2 ">
          <div className="">
            <Session className="w-7 h-7" />
          </div>
          <div className="flex-1 text-start">
            <p className="text-xs text-[#F1935C] font-medium">Session ID</p>
            <p className="text-xs font-medium text-[#6F6D7C]">
              {modSessionToken}
            </p>
          </div>
        </div>

        {/* Date Display */}
        <div className="flex items-center gap-2">
          <div className="">
            <Target className="w-7 h-7" />
          </div>
          <div className="flex-1 text-start">
            <p className="text-xs text-[#34656D] font-medium">Target Date</p>
            <p className="text-xs font-medium text-[#6F6D7C]">{TargetDate}</p>
          </div>
        </div>

        {/* Optional Status Badge (can be enabled later) */}
        {/* 
      <div className="flex items-center gap-2 bg-green-50 px-4 py-3 rounded-lg border border-green-200">
        <div className="relative">
          <div className="w-2.5 h-2.5 bg-green-500 rounded-full"></div>
          <div className="absolute inset-0 w-2.5 h-2.5 bg-green-500 rounded-full animate-ping"></div>
        </div>
        <span className="text-xs font-semibold text-green-700">ACTIVE</span>
      </div>
      */}
      </div>
    </div>
  );
};

export default SessionInfo;
